<template>
  <div class="card questions">
    <div class="card-header">
      <h3 class="card-title">{{ $t('page.title.reports') }}</h3>
    </div>
    <div class="card-body">
      <b-card no-body>
        <b-tabs card>
          <!-- Add your b-tab components here -->
          <template #tabs-end>
            <b-nav-item :active="$route.name === 'quick-summary'"
                         @click="goToPage('quick-summary')">
              {{$t('reports.tab.quick_summary')}}</b-nav-item>
            <b-nav-item :active="$route.name === 'affiliate-quick-summary'"
                        @click="goToPage('affiliate-quick-summary')">
              {{$t('reports.tab.affiliate_quick_summary')}}</b-nav-item>
            <b-nav-item :active="$route.name === 'management'"
                        @click="goToPage('management')">
              {{$t('reports.tab.management')}}</b-nav-item>
            <b-nav-item :active="$route.name === 'marketing'"
                        @click="goToPage('marketing')">
              {{$t('reports.tab.marketing')}}</b-nav-item>
            <b-nav-item :active="$route.name === 'profile-countries' || $route.name === 'profile-countries-details'"
                        @click="goToPage('profile-countries')">
              {{$t('reports.tab.profile_countries')}}</b-nav-item>
          </template>
          <template #default>
            <div class="tab-pane active card-body">
              <router-view></router-view>
            </div>
          </template>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>

export default {
  props: ['apiKey'],
  components: {
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    goToPage(name) {
      this.$router.push({name: name});
    },
  }
}
</script>
